import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { LanguageApiRoaming } from '@api-roaming/models/language-api-roaming';
import { RxEffects } from '@rx-angular/state/effects';
import { LogoComponent } from '@shared/components/logo/logo.component';


/**
 * Toolbar panel
 */
@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, LogoComponent, MatSelectModule, ReactiveFormsModule],
    providers: [RxEffects],
})
export class ToolbarComponent implements OnInit, OnChanges {
    readonly #effects: RxEffects = inject(RxEffects);

    /**
     * Don't show logo flag
     */
    @Input()
    public hideLogo: boolean;

    /**
     * Don't show burger menu flag
     */
    @Input()
    public hideBurgerMenu: boolean;

    /**
     * Selected language
     */
    @Input()
    public currentLang: string;

    /**
     * List of all available languages
     */
    @Input() public languages: LanguageApiRoaming[];
    /**
     * Language selection handler
     */
    @Output() public readonly switchLang: EventEmitter<string> = new EventEmitter<string>();
    /**
     * Click by burger menu event
     */
    @Output() public readonly burgerMenuClick: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('select')
    public select: MatSelect;

    public readonly selectControl: UntypedFormControl = new UntypedFormControl();

    public ngOnInit(): void {
        this.#effects.register(
            this.selectControl.valueChanges,
            (value: LanguageApiRoaming) => {
                if (value && value.code !== this.currentLang) {
                    this.switchLang.emit(value.code?.toLowerCase());
                    this.select?.close();
                }
            },
        );
    }

    public ngOnChanges(): void {
        if (this.languages && this.currentLang) {
            this.selectControl.setValue(this.languages.find((a: LanguageApiRoaming) => a.code.toLowerCase() === this.currentLang), {
                emitEvent: false,
            });
        }
    }
}
